import { render, staticRenderFns } from "./AddMessage.vue?vue&type=template&id=e443720c&scoped=true"
import script from "./AddMessage.vue?vue&type=script&lang=js"
export * from "./AddMessage.vue?vue&type=script&lang=js"
import style0 from "./AddMessage.vue?vue&type=style&index=0&id=e443720c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e443720c",
  null
  
)

export default component.exports